export default "__VITE_ASSET__CyA_phg$__"